// extracted by mini-css-extract-plugin
module.exports = {"grouping_count":"index_grouping_count_hAc5o","right":"index_right_1lEnZ"};